import type { WebappResponse } from '@eventbrite/event-listing-service-client';

import styles from './PresenterInfo.module.scss';

interface PresenterInfoProps {
  presenterInfo: NonNullable<WebappResponse['presenterInfo']>;
}

export const PresenterInfo: React.FC<PresenterInfoProps> = ({ presenterInfo }) => {
  if (!presenterInfo?.presenter) {
    return null;
  }

  return <div className={styles.wrapper}>{presenterInfo.presenter}</div>;
};
